<div *ngIf="data.isCashIn">
    <div class="modal-header">
        {{ 'CASH_IN' | translate }}
    </div>
    <form [formGroup]="cashInForm" (ngSubmit)="closeDialog()">
        <div class="modal-body">
            <input id="cashIn" type="text" class="form-control" formControlName="cashIn">
        </div>
        <div class="modal-footer">
            <button class="btn btn-light" mat-dialog-close>{{'CLOSE' | translate}}</button>
            <button class="btn btn-primary">{{'CASH_IN' | translate}}</button>
        </div>
    </form>  
</div>

<div *ngIf="data.isCashOut">
  <div class="modal-header">
      {{ 'CASH_OUT' | translate }}
  </div>
  <form [formGroup]="cashOutForm" (ngSubmit)="closeDialog()">
      <div class="modal-body">
          <input id="cashOut" type="text" class="form-control" formControlName="cashOut">
      </div>
      <div class="modal-footer">
          <button class="btn btn-light" mat-dialog-close>{{'CLOSE' | translate}}</button>
          <button class="btn btn-primary">{{'CASH_OUT' | translate}}</button>
      </div>
  </form>  
</div>

<div *ngIf="!data.isCashIn && !data.isCashOut">
    <div class="modal-header"></div>
    <form [formGroup]="periodicDateForm" (ngSubmit)="closeDialog()">
        <div class="modal-body">
            <div class="form-group">
                <label for="">{{'DATE_FROM' | translate}}</label>
                <input type="date" class="form-control" formControlName="periodicDateFrom">
            </div>  
            <div class="form-group">
                <label for="">{{'DATE_TO' | translate}}</label>
                <input type="date" class="form-control" formControlName="periodicDateTo">
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-light" mat-dialog-close>{{'CLOSE' | translate}}</button>
            <button class="btn btn-primary" >{{'PRINT' | translate}}</button>
        </div>
    </form>
</div>
 